const defaultViewParams = {
  token: 'loading.generic',

  // Automatically hide loading overlay when all promises are completed
  autoHide: true,

  // Show a loading bar and a notice for potentially long operations
  longOperation: false,
};

module.exports = class {

  static $inject = [
    '$rootScope',
    '$state',
    '$timeout',
  ];

  constructor($rootScope, $state, $timeout) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$timeout = $timeout;

    this.isLoading = false;
    this.promises = [];
    this.viewParams = angular.extend({}, defaultViewParams);
  }

  show(params = defaultViewParams) {
    this.isLoading = true;

    // Override view params with current promise's loading params
    this.viewParams = angular.extend({}, defaultViewParams, params);

    // Broadcast status for Loading component controller
    this.$rootScope.$broadcast('loading:started');
  }

  hide() {
    if (!this.isLoading) {
      return;
    }

    this.isLoading = false;

    // Broadcast status for Loading component controller
    this.$rootScope.$broadcast('loading:completed');
  }

  waitForAll(promises, params) {
    promises.forEach((promise) => {
      this.waitFor(promise, params);
    });
  }

  waitFor(promise, params) {
    promise.then(() => {
      this.unregister(promise);
    }, () => {
      this.unregister(promise);
    });

    // Override view params with current promise's loading params
    this.viewParams = angular.extend({}, defaultViewParams, params);

    this.register(promise);
  }

  register(promise) {
    if (!this.isLoading) {
      this.show();
    }

    this.promises.push(promise);
  }

  unregister(element) {
    _.remove(this.promises, element);

    if (!this.promises.length && this.viewParams.autoHide) {
      this.hide();
    }
  }
};



// WEBPACK FOOTER //
// ./main/services/loading-service.js